import React from 'react'
import { Button, Paper, Spinner, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface InitialContentProps {
  patientPhone: string
  patientFirstName: string
  totalSchedules: number
  isFetchingPatientScheduleList: boolean
  handleContinueReschedule: () => void
}

export const InitialContent: React.FC<InitialContentProps> = ({ 
  patientPhone,
  patientFirstName,
  totalSchedules = 0,
  handleContinueReschedule,
  isFetchingPatientScheduleList
}) => {

  if (isFetchingPatientScheduleList) {
    return (
      <S.SpinnerWrapper>
        <Spinner />
      </S.SpinnerWrapper>
    )
  }

  return (
    <S.Container>
      <Typography variant='content2' color='danger' center>
        <strong>Atenção:</strong>{' '}
          tenha certeza de que esta mudança seja alinhada previamente com o paciente. <br />
        <strong>Fale com ele</strong> e combine:
      </Typography>

      <Typography 
        variant='content1'
        color='danger' 
        center 
        weight='bold' 
        customClassName='patientPhoneText'
      >
        {patientPhone}
      </Typography>

      {totalSchedules > 0 
        ? (
          <Paper variant='warning' customClassName='infoSchedulePaper'>
            <Typography variant='content2' weight='bold'> INFORME AO PACIENTE: </Typography>
            <Typography variant='content2'>
              {patientFirstName}, você possui <strong>{totalSchedules} consultas <br /> agendadas.</strong>
            </Typography>
        
            <Typography variant='content2'>
                Ao remarcar toda a reserva, as consultas existentes também 
                serão <strong>remarcadas para os novos dias e horários definidos.</strong>
            </Typography>
        
            <Typography variant='content2'>
                Deseja continuar?
            </Typography>
          </Paper>
        )
        : null
      }

      <Paper variant='warning' customClassName='warningPaper'>
        <Typography variant='content2'>
          Ao concluir a mudança, os dias e o horários anteriores são 
          liberados para outros pacientes agendarem (caso esteja cadastrado em sua disponibilidade).
        </Typography>
      </Paper>

      <Button
        variant='contained'
        onClick={handleContinueReschedule}
        customClassName='actionButton'
      >
        Continuar
      </Button>
    </S.Container>
  )
}